import React from 'react';

import PropTypes from 'prop-types';

class MarkerDescription extends React.PureComponent {
  render() {
    const {marker: l} = this.props
    return (
      <div className="MarkerPopup">
        <h4 className="name">{l.NOME_SEDE}</h4>
        <div className="address">
          {l.VIA} - {l.CAP} {l.CITTA}
        </div>

        <div className="tel">
          Telefono <span>{l.TELEFONO}</span>
        </div>

        <div className="email">
          E-Mail <span>{l.EMAIL}</span>
        </div>
      </div>
    );
  }
}

MarkerDescription.propTypes = {
  marker: PropTypes.object.isRequired,
};

export default MarkerDescription;
